import type { Player } from "../api/gameData";

interface TurnIndicatorProps {
  currentPlayer: Player;
  winner: Player | null;
  isDraw: boolean;
}

export function TurnIndicator({ currentPlayer, winner, isDraw }: TurnIndicatorProps) {
  if (winner) {
    const color = winner === "X" ? "var(--color-x)" : "var(--color-o)";
    return (
      <div
        className="text-center"
        style={{ animation: "slideUp 0.3s ease-out" }}
      >
        <span
          className="text-xl sm:text-2xl font-bold tracking-wide"
          style={{ color, fontFamily: "var(--font-display)" }}
        >
          Player{" "}
          <span style={{ fontFamily: "var(--font-mono)" }}>{winner}</span>{" "}
          wins!
        </span>
      </div>
    );
  }

  if (isDraw) {
    return (
      <div
        className="text-center"
        style={{ animation: "slideUp 0.3s ease-out" }}
      >
        <span
          className="text-xl sm:text-2xl font-bold tracking-wide"
          style={{ color: "var(--color-draw)", fontFamily: "var(--font-display)" }}
        >
          It&rsquo;s a draw!
        </span>
      </div>
    );
  }

  const color = currentPlayer === "X" ? "var(--color-x)" : "var(--color-o)";

  return (
    <div className="text-center">
      <span
        className="text-base sm:text-lg tracking-wide"
        style={{ color: "var(--game-text-dim)", fontFamily: "var(--font-display)" }}
      >
        Turn:{" "}
        <span
          className="font-bold text-xl sm:text-2xl"
          style={{
            color,
            fontFamily: "var(--font-mono)",
            animation: "pulseSubtle 2s ease-in-out infinite",
            display: "inline-block",
          }}
        >
          {currentPlayer}
        </span>
      </span>
    </div>
  );
}
